import { NavLink } from 'react-router-dom';

import { AppRoute, ButtonType } from '../../types/enums';
import Button from '../Button/Button';
import Popup from '../Popup/Popup';

const LimitReachedPopup = ({ hide }: { hide: () => void }) => {
  return (
    <Popup show onHide={hide} title="You have reached the limits of your plan">
      <div>
        <p>
          Upgrade your plan or{' '}
          <NavLink className="color-orange" to={AppRoute.CONTACT_US}>
            contact us
          </NavLink>{' '}
          to increase your limits.
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <NavLink to={AppRoute.UPGRADE}>
            <Button type={ButtonType.PRIMARY}>See plans</Button>
          </NavLink>

          <NavLink to={AppRoute.CONTACT_US}>
            <Button type={ButtonType.SECONDARY}>Contact support</Button>
          </NavLink>
        </div>
      </div>
    </Popup>
  );
};

export default LimitReachedPopup;
